"use client";

import { AiOutlineExclamationCircle } from "react-icons/ai";
import toaster from "react-hot-toast";

import { SsoAuthToastProps } from "../types";
import "./ssoAuthToast.scss";

export const SsoAuthToast = ({ toast, message }: SsoAuthToastProps) => {
  return (
    <div className="sso-auth-toast">
      <AiOutlineExclamationCircle className="sso-auth-toast__icon" />
      <p className="sso-auth-toast__message">{message}</p>
      <div className="sso-auth-toast__button">
        <span onClick={() => toaster.dismiss(toast?.id)}>&#10005;</span>
      </div>
    </div>
  );
};
